export enum Alignments {
  CENTER = 'center',
  CENTER_BOTTOM = 'centerBottom',
  LEFT = 'left',
  LEFT_BOTTOM = 'leftBottom',
  LEFT_TOP = 'leftTop',
  RIGHT = 'right',
  RIGHT_BOTTOM = 'rightBottom',
  RIGHT_TOP = 'rightTop'
}
